// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screening-hero-section {
  padding: 60px 0;
  position: relative;
  overflow: hidden;
  color: white;
}

.bg-video {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1;
}

/* ✅ Align both columns perfectly */
.text-container {
  z-index: 2;
  padding: 30px 20px;
  text-align: left;
  max-width: 95%;
}

/* ✅ Makes both sides equal width visually */
.screening-hero-section .col-md-6 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

/* ✅ Title alignment */
.screening_hero_title {
  font-size: 2.8rem;
  font-weight: 500;
  margin-bottom: 1rem;
  border-bottom: 2px solid #e9cd21;
  padding-bottom: 0.5rem;
}

/* ✅ Subtitle alignment */
.screening_hero_subtitle {
  font-size: 1.6rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

/* ✅ Readable paragraph spacing */
.screening_content {
  font-size: 1.05rem;
  line-height: 1.55;
  max-width: 95%;
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/SCREENING/SECTIONS/HERO/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".screening-hero-section {\n  padding: 60px 0;\n  position: relative;\n  overflow: hidden;\n  color: white;\n}\n\n.bg-video {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  object-fit: cover;\n  transform: translate(-50%, -50%);\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 1;\n}\n\n/* ✅ Align both columns perfectly */\n.text-container {\n  z-index: 2;\n  padding: 30px 20px;\n  text-align: left;\n  max-width: 95%;\n}\n\n/* ✅ Makes both sides equal width visually */\n.screening-hero-section .col-md-6 {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n/* ✅ Title alignment */\n.screening_hero_title {\n  font-size: 2.8rem;\n  font-weight: 500;\n  margin-bottom: 1rem;\n  border-bottom: 2px solid #e9cd21;\n  padding-bottom: 0.5rem;\n}\n\n/* ✅ Subtitle alignment */\n.screening_hero_subtitle {\n  font-size: 1.6rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n/* ✅ Readable paragraph spacing */\n.screening_content {\n  font-size: 1.05rem;\n  line-height: 1.55;\n  max-width: 95%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
